import axios from 'axios';

export const extractErrorCollectionToMessageList = ({ data = {} }, defaultReturn) => {
  if (data && data.Errors) {
    return data.Errors.reduce((errors, e) => [...errors, e.Message], []);
  }
  return defaultReturn;
};

export const getShipFromsWithLocationContacts = () => {
  return axios
    .get('/seller/shipfrom/')
    .then(({ status, data }) => ({
      status,
      data,
    }))
    .catch(({ response }) => ({
      status: response.status,
      data: extractErrorCollectionToMessageList(response, []),
    }));
};

export const getShipFromContacts = (shipFromId) => {
  return axios.get(`/seller/shipfrom/${shipFromId}/contacts`).then(({ status, data }) => ({
    status,
    data,
  }));
};

export const addShipFromContact = (shipFromId, contact) => {
  return axios.post(`/seller/shipfrom/${shipFromId}/contacts`, contact).then(({ data, status }) => ({
    data,
    status,
  }));
};

export const editShipFromContact = (shipFromId, shipFromContactId, contact) => {
  return axios.put(`/seller/shipfrom/${shipFromId}/contacts/${shipFromContactId}`, contact).then(({ data, status }) => ({
    data,
    status,
  }));
};

export const deleteShipFromContact = (shipFromId, shipFromContactId) => {
  return axios.delete(`/seller/shipfrom/${shipFromId}/contacts/${shipFromContactId}`, {}).then(({ status }) => ({
    status,
  }));
};

export const getAvailableProviders = () => {
  return axios
    .get('/carrierPickup/providers')
    .then(({ data = {} }) => ({
      sellerLabelProviderIds: data.sellerLabelProviderIds || [],
      providerDetails: data.providerDetails || [],
    }))
    .catch(() => {
      throw new Error('getAvailableProviders Error');
    });
};

// TODO: Add in filters here
export const getScheduledPickups = () => {
  return axios.get('/carrierPickup').then(({ status, data }) => ({
    status,
    data,
  }));
};

export const schedulePickup = (pickupRequest) => {
  return axios.post('/carrierPickup', pickupRequest).then(({ data, status }) => ({
    data,
    status,
  }));
};

const cancelPickupWithRemarks = (scheduledPickupId, cancellationRemarks) => {
  return axios
    .post(`/carrierPickup/${scheduledPickupId}/cancel`, {
      data: {
        cancellationRemarks,
      },
    })
    .then(({ status }) => ({
      status,
    }));
};

const cancelPickupWithoutRemarks = (scheduledPickupId) => {
  return axios.delete(`/carrierPickup/${scheduledPickupId}`, {}).then(({ status }) => ({
    status,
  }));
};

export const cancelPickup = (scheduledPickupId, cancellationRemarks = '') => {
  if (cancellationRemarks) {
    return cancelPickupWithRemarks(scheduledPickupId, cancellationRemarks);
  }
  return cancelPickupWithoutRemarks(scheduledPickupId);
};

export const getShipFromFulfillmentSummary = (
  shipFromId,
  sellerProviderId,
  pickupDate,
  pickupServiceCode,
  timeZoneIana,
  shouldUseDateRangeFromToday,
) => {
  return axios
    .get('/carrierPickup/fulfillmentSummary', {
      params: {
        shipFromId,
        sellerProviderId,
        pickupDate,
        pickupServiceCode,
        timeZoneIana,
        shouldUseDateRangeFromToday,
        // TODO: the backend should change to shouldUseDateRangeFromToday but this for interim speed
        shouldIncludeCurrentTimeZoneDate: shouldUseDateRangeFromToday,
      },
    })
    .then(({ data }) => data);
};

export const getLastPickupData = (shipFromId) => {
  return axios
    .get('/carrierPickup/lastPickup', {
      params: {
        shipFromId,
      },
    })
    .then(({ data }) => data)
    .catch(() => ({
      lastPickupInstructions: '',
      lastAccessCode: '',
    }));
};
